<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense nav>
        <div
          v-for="navigationItem in navigationItems"
          :key="navigationItem.title"
          class="mb-3"
        >
          <v-list-item
            link
            :to="navigationItem.route"
            active-class="primary--text"
            v-if="!navigationItem.childrens"
          >
            <v-list-item-icon>
              <v-icon>{{ navigationItem.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ navigationItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

<!-- 
          <v-list-group
            v-else
            :value="
              navigationItem.catchRoutes.includes($router.currentRoute.path)
            "
          > -->
          <v-list-group v-else v-model="navigationItem.active">
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>
                  {{ navigationItem.icon }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  navigationItem.title
                }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(subitem, index) in navigationItem.childrens"
              :key="index"
              class="ml-5"
              :to="subitem.route"
            >
              <v-list-item-icon>
                <v-icon>{{ subitem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ subitem.title }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left elevation="3" dense color="white">
      <v-app-bar-nav-icon @click="drawer = !drawer"> </v-app-bar-nav-icon>
      <v-toolbar-title class="pl-0">
        <v-img
          :src="API_BASE_URL + '/web_front/icon_logo.svg'"
          max-height="40px"
          max-width="100px"
          contain
        ></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu transition="slide-y-transition" bottom offset-y right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn large icon v-bind="attrs" v-on="on">
            <v-avatar
              size="35"
              v-if="user.profile_url != null"
              class="cursor-pointer"
            >
              <img
                :src="
                  API_BASE_URL +
                  '/uploads/super_admins/profile_pics/' +
                  user.profile_url
                "
                :alt="user.name"
              />
            </v-avatar>
            <v-avatar
              v-if="user.profile_url == null"
              color="secondary"
              class="white--text cursor-pointer"
              size="35"
            >
              <span class="font-30">{{
                user.name ? user.name.charAt(0) : ""
              }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense nav color="primary--text">
          <v-list-item
            v-for="(menuItem, i) in menuItems"
            :key="i"
            :to="menuItem.route"
          >
            <v-list-item-icon>
              <v-icon right>{{ menuItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon right>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <Alert />

    <v-main class="blue-grey lighten-5">
      <router-view @changeProfilePic="changeProfilePic" />
    </v-main>
  </v-app>
</template>

<script>
import Alert from "../../Alert.vue";
import { mapMutations } from "vuex";

export default {
  name: "App",

  components: {
    Alert,
  },

  data: () => ({
    drawer: true,
    navigationItems: [
      {
        title: "Dashboard",
        icon: "mdi-view-dashboard",
        route: "/superadmin/dashboard",
      },
      {
        title: "Society",
        icon: "mdi-office-building",
        active: false,
        catchRoutes: [
          "/superadmin/society/requests",
          "/superadmin/society/list",
        ],
        childrens: [
          {
            title: "Requests",
            icon: "mdi-share-outline",
            route: "/superadmin/society/requests",
          },
          {
            title: "List",
            icon: "mdi-format-list-bulleted",
            route: "/superadmin/society/list",
          },
        ],
      },
      {
        title: "Modules",
        icon: "mdi-view-quilt-outline",
        route: "/superadmin/modules",
      },
      {
        title: "Feedback",
        icon: "mdi-comment-outline",
        route: "/superadmin/feedback",
      },
      {
        title: "CMS",
        icon: "mdi mdi-shield-outline",
        active: false,
        catchRoutes: [
          "/superadmin/privacy",
          "/superadmin/term_condition",
        ],
        childrens: [
          {
            title: "Privacy policy",
            icon: "mdi mdi-lock",
            route: "/superadmin/privacy",
          },
          {
            title: "Terms condition",
            icon: "mdi mdi-file-document-outline",
            route: "/superadmin/term_condition",
          },
        ],
      },
      {
        title: "Plan",
        icon: "mdi-diamond-outline",
        route: "/superadmin/plan",
      },
      {
        title: "Payment",
        icon: "mdi-credit-card-outline",
        route: "/superadmin/payment",
      },
      {
        title: "FAQ",
        icon: "mdi-help-circle-outline",
        route: "/superadmin/faqs",
      },
    ],
    menuItems: [
      {
        title: "Profile",
        icon: "mdi-account-outline",
        route: "/superadmin/profile",
      },
      {
        title: "Change Password",
        icon: "mdi-lock-outline",
        route: "/superadmin/changePassword",
      },
    ],
    user: {
      name: "",
      email: "",
    },
  }),

  methods: {
    ...mapMutations("alert", ["setAlert"]),
    logout() {
      let _self = this;

      _self.loading = true;

      _self.$axios.post("/superadmin/logout").then((response) => {
        let data = response.data;
        _self.loading = false;

        if (data.status) {
          localStorage.removeItem("user");
          this.$router.push({ path: "/superadmin/login" });
        } else {
          if (data.errors) {
            for (let i = 0; i < data.errors.length; i++) {
              _self.errors[data.errors[i].field] = data.errors[i].message;
            }
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red variant-2",
              timeout: "2000",
              message: data.message,
            });
          }
        }
      });
    },
    changeProfilePic() {
      let user = JSON.parse(localStorage.getItem("user"));
      this.user.profile_url = user.profile_url;
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
};
</script>
